<template>
    <div class="dc-certificates">
        <app-docs :docs="certificates" :list="false"></app-docs>
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import Certificates from './certificates.json'
import ShareButton from "../shared/ShareButton";
import Docs from "../shared/Docs";
export default {
  components: {
    appShareButton: ShareButton,
    appDocs: Docs
  },
  data() {
      return {
          certificates: Certificates
      }
  }
};</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/download-center/Certificates.vue